// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Yty8m","footer":"ModalError_footer__26JRl"};